import React from 'react';

import Image from '../../library/image/image';

import styles from './group-affiliation-promotion-id-me-button.scss';

interface GroupAffiliationPromotionIdMeButtonProps {
  height?: string;
  isAppliedPromotion?: boolean;
  openVerificationWindow?: () => void;
  width?: string;
}

function GroupAffiliationPromotionIdMeButton(
  props: GroupAffiliationPromotionIdMeButtonProps
) {
  const { height, isAppliedPromotion, openVerificationWindow, width } = props;

  return (
    <>
      {!isAppliedPromotion && (
        <button
          className="group-affiliation-promotion-id-me-button"
          onClick={openVerificationWindow}
        >
          <Image
            alt="ID.me Logo"
            className={styles['logo']}
            height={height ?? '40'}
            loading="lazy"
            src="/images/idme-button.svg"
            width={width ?? '218'}
          />
        </button>
      )}
    </>
  );
}

export default GroupAffiliationPromotionIdMeButton;
